import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import '@zippytech/react-toolkit/SplitContainer/index.css';
import Home from './Designer/home';
import UpgradePlan from './../upgrade/drive/UpgradePlan';
import { push } from "react-router-redux";
class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    if (!this.props.user.isVerified) {
      return dispatch(push('/updatePassword/' + this.props.user._id));
    }
    dispatch.app.setCurrentContext("acc-home");
    if (this.props.user && this.props.user.accounts && this.props.user.accounts.length === 1 && this.props.user.accounts[0].isActive === false && this.props.user.accounts[0].role === 'user') {
      dispatch.account.setDeActivateAccountModal(true);
    }
  }

  render() {
    return (
      <div>
        <Route exact path="/app/:accountId/dashboard" render={() => (<Home  {...this.props} />)} />
        <Route exact path="/app/:accountId/upgrade" render={() => (<UpgradePlan  {...this.props} />)} />
      </div>
    );
  }
}

function mapStateToProps(state) {

  return {
    accountLogoObjectCloudinary: state.registerAccount.accountLogoObjectCloudinary,
    loaderStatus: state.registerAccount.loaderBar,
    updateAccountLoader: state.loading.effects.registerAccount.UpdateAccountDetails,
    selectedAccount: state.app.selectedAccount,
    organizations: state.app.organizations,
    user: state.app.user,
    accessToken: state.login.accessToken,
    userCache: state.app.userCache,
    InviteUserLoader: state.loading.effects.invite.sendInviteByAccountAsync,
    orgCreationError: state.app.orgCreationError,
    accountSubscriptionDetail: state.app.accountSubscriptionDetail,
    addedAccountUser: state.invite.addedAccountUser,
    selectedOrganisation: state.app.selectedOrganisation,
    envData: state.app.envData,
    worspacesLoading: state.loading.effects.account.getAcountUserWorkspaces,
    accountSelectorLoader: state.account.accountSelectorLoader,
    organizationList: state.account.organizationList,
    userWorkspacesTotal: state.account.userWorkspacesTotal,
    openViewAccountFlag: state.account.openViewAccountFlag,
    tableFilterQuery: state.app.tableFilterQuery
  };
}

const connectedDashboardDesignerPage = withRouter(connect(mapStateToProps)(Dashboard));
export { connectedDashboardDesignerPage as Dashboard }; 
